import React from 'react'
import "./style.scss"
import Sortition from '../sortition'


const DivTable = ({ columns, options, hasSorting, handleChange, dataList, setDataListFromItem, customProps, theme, dataListToDisplay }) => {
    return (
        <>
            <div className="table-view" id="gsfTable">
                <Sortition
                    columns={columns}
                    options={options}
                    hasSorting={hasSorting}
                    setSortText={handleChange} isDiv={true} />
                <div className='tv-body' >

                    {dataListToDisplay.map((item, idx) => <div className='tv-body-row' key={idx}>
                        {columns.map((column, idx2) => {
                            if (column.component) {
                                return (
                                    <div key={idx2}>{column.component({ item, dataList, index: idx, setDataListFromItem, ...customProps })}</div>
                                )
                            } else {
                                let className = '';
                                if (column.rowClassName && Array.isArray(column.rowClassName)) {
                                    column.rowClassName.map(_item => {
                                        if (item[_item.property] === _item.value) {
                                            className += _item.className
                                        }
                                    })
                                }
                                if (column.display) {
                                    return (
                                        <div className={className}
                                            key={idx2}>{item[column.property]}</div>)
                                }
                            }

                        })}
                        {options && <div>
                            {options(item)}
                        </div>}
                    </div>)}

                </div>
            </div>

        </>


    )
}

export default DivTable
